window.Products.Clothing.FittedTankTopRegular = function() {};

window.Products.Clothing.FittedTankTopRegular.inherits(window.Products.Clothing.FittedTankTop);
window.Products.Clothing.FittedTankTopRegular.has_3d = true;
window.Products.Clothing.FittedTankTopRegular.id = '65-regular';
window.Products.Clothing.FittedTankTopRegular.saveId = 65;
window.Products.Clothing.FittedTankTopRegular.slug = 'fitted-tank-top-regular';
window.Products.Clothing.FittedTankTopRegular.dpi = 150;